export default "__VITE_ASSET__CRAMSLky__"